import React, { useState, useEffect, ReactElement, useRef } from 'react';
import { connect } from 'react-redux';
import { HEADER_MOBILE_BREAKPOINT } from '../../../constants/constants';

import { Menu } from './styles';
import { NavLink } from 'react-router-dom';
import Routes from '../../../constants/routes';
import { CUSTOMER_ROLES } from '../../../constants/roles';

const CustomerMenu = (props: any): ReactElement => {
	const maxLength = 20;
	const customerAdminRoles = [CUSTOMER_ROLES.Admin.name, CUSTOMER_ROLES.Moderator.name, CUSTOMER_ROLES.Owner.name];
	const isAdmin = customerAdminRoles.includes(props.user.customerRole);

	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	const isCompact = (): boolean => {
		return windowWidth < HEADER_MOBILE_BREAKPOINT;
	};

	const hasMultipleLocations = (): boolean => {
		return props.user.hasMultipleLocations;
	};

	// Function to update window width state
	const updateWindowWidth = () => {
		setWindowWidth(window.innerWidth);
	};

	const truncateString = (str: string, maxLength: number) => {
		if (str.length > maxLength) {
			return str.slice(0, maxLength) + '...';
		}
		return str;
	};

	// Add event listener when component mounts
	useEffect(() => {
		window.addEventListener('resize', updateWindowWidth);

		// Remove event listener when component unmounts
		return () => {
			window.removeEventListener('resize', updateWindowWidth);
		};
	}, []);

	return (
		<Menu>
			<ul className='menu-items'>
				{isCompact() && (
					<>
						{hasMultipleLocations() && (
							<li>
								<i className='fa-regular fa-display-chart-up'></i>
								<NavLink to={Routes.DashboardCorporate}>Company Summary</NavLink>
							</li>
						)}
						<li>
							<i className='fa-regular fa-chart-simple'></i>
							<NavLink to={Routes.DashboardLocation}>Dashboard</NavLink>
						</li>
						<li>
							<i className='fa-regular fa-list-check'></i>
							<NavLink to={Routes.Tasks}>Tasks</NavLink>
						</li>
						<li>
							<i className='fa-regular fa-file-chart-column'></i>
							<NavLink to={Routes.Reports}>Reports</NavLink>
						</li>
						{isAdmin && (
							<li>
								<i className='fa-regular fa-user-plus'></i>
								<NavLink to={Routes.AdminHome}>Admin</NavLink>
							</li>
						)}
					</>
				)}
				<li>
					<i className='fa-regular fa-user'></i>
					<NavLink to={Routes.ProfileUser}>Profile</NavLink>
				</li>
				<li>
					<i className='fa-regular fa-envelope'></i>
					<NavLink to={Routes.ProfileNotifications}>Email Notifications</NavLink>
				</li>
				{props.isSSOUser == false && (
					<li>
						<i className='fa-regular fa-id-card'></i>
						<a href='#' onClick={props.onAddSubscription}>
							Add Subscription
						</a>
					</li>
				)}

				<li>
					<i className='fa-regular fa-circle-question'></i>
					<a href='https://ehsolution.zendesk.com/hc/en-us'>FAQ & Tutorials</a>
				</li>
				<li>
					<i className='fa-regular fa-headset'></i>
					<a href='#' onClick={props.showSupportDrawer}>
						Support
					</a>
				</li>
				<hr />
				{props.user.activeUserSubscriptions && (
					<li>
						<i className='fa-regular fa-arrows-rotate'></i>
						<select name='subscriptions' onChange={props.onChangeSubscription} value={props.user.currentSubscriptionId.toString()}>
							{props.user.activeUserSubscriptions.map((option) => (
								<option key={option.id} value={option.id} title={option.name}>
									{truncateString(option.name, maxLength)}
								</option>
							))}
						</select>
					</li>
				)}
				<li>
					<i className='fa-regular fa-power-off'></i>
					<NavLink to={Routes.LogoutPage}>Sign Out</NavLink>
				</li>
			</ul>
		</Menu>
	);
};

function mapStateToProps(state) {
	return {
		user: state.user,
	};
}

export default connect(mapStateToProps)(CustomerMenu);
